// extracted by mini-css-extract-plugin
export var active = "_1n-7";
export var container = "_1n-0";
export var evenWidth = "_1n-4";
export var large = "_1n-5";
export var outlet = "_1n-8";
export var slide = "_1n-2";
export var small = "_1n-6";
export var tab = "_1n-3";
export var tabs = "_1n-1";